import type { FunctionComponent } from "react"

import { NetlinkingBlockItem } from "@/modules/jobSearchPrefiltered/components/PrefilteredAside/NetlinkingBlock/NetlinkingBlockItem"
import { useContent } from "@/modules/jobSearchPrefiltered/hooks/useContent"

import styles from "./NetlinkingBlocks.module.css"

export const NetlinkingBlocks: FunctionComponent = () => {
  const { data } = useContent()

  if (!data) {
    return null
  }

  const { currentSlug, netlinkingBlocks } = data

  return (
    <>
      {netlinkingBlocks.map(netlinkingBlock => (
        <NetlinkingBlockItem
          key={netlinkingBlock.type}
          data={netlinkingBlock}
          currentData={currentSlug}
          className={styles.block}
        />
      ))}
    </>
  )
}
